import apiClient from '../client';
import type { Database } from '@/lib/supabase/supabase-types';

type LessonProgress = Database['public']['Tables']['lesson_progress']['Row'];
type LessonProgressUpdate = Database['public']['Tables']['lesson_progress']['Update'];

export type LessonProgressUpsertData = {
  seconds_watched?: number;
  percent_watched?: number; // 0-100
  last_position_sec?: number;
  furthest_watched_sec?: number;
};

export const lessonProgressService = {
  /**
   * Get all lesson progress entries for current user
   */
  getMyProgress: (): Promise<LessonProgress[]> => 
    apiClient.get<LessonProgress[]>('/lesson-progress') as unknown as Promise<LessonProgress[]>,
  
  /**
   * Get lesson progress for current user and specific lesson
   */
  getProgressByLesson: (lessonId: string): Promise<LessonProgress | null> => 
    apiClient.get<LessonProgress | null>(`/lesson-progress/lesson/${lessonId}`) as unknown as Promise<LessonProgress | null>,
  
  /**
   * Get all lesson progress entries for current user in a specific course
   */
  getProgressByCourse: (courseId: string): Promise<LessonProgress[]> => 
    apiClient.get<LessonProgress[]>(`/lesson-progress/course/${courseId}`) as unknown as Promise<LessonProgress[]>,
  
  /**
   * Create or update lesson progress (upsert)
   */
  upsertProgress: (lessonId: string, data: LessonProgressUpsertData): Promise<LessonProgress> => 
    apiClient.post<LessonProgress>(`/lesson-progress/lesson/${lessonId}`, data) as unknown as Promise<LessonProgress>,
  
  /**
   * Update lesson progress (only if entry exists)
   */
  updateProgress: (lessonId: string, data: LessonProgressUpdate): Promise<LessonProgress> => 
    apiClient.patch<LessonProgress>(`/lesson-progress/lesson/${lessonId}`, data) as unknown as Promise<LessonProgress>,
  
  /**
   * Mark lesson as complete (100% watched)
   */
  markComplete: (lessonId: string): Promise<LessonProgress> => 
    apiClient.post<LessonProgress>(`/lesson-progress/lesson/${lessonId}/complete`) as unknown as Promise<LessonProgress>,
  
  /**
   * Delete lesson progress for current user and lesson
   */
  deleteProgress: (lessonId: string): Promise<void> => 
    apiClient.delete(`/lesson-progress/lesson/${lessonId}`),
};

